module.exports = __webpack_public_path__ + "static/media/dj.556d36ea.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/dj.svg
// module id = 806
// module chunks = 0